import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode4Home({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="SALLANTI KARTI HOME MAİN" />
}
